import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const FiltersSectionSkeleton: React.FC = () => {
  return (
    <div className="m-2">
      {/* Top section with sales data */}
      <div className="flex flex-col lg:flex-row gap-5 mb-5">
        {/* Left panel - Sales amount */}
        <div className="p-5 rounded-lg shadow w-full lg:w-72">
          <Skeleton width={120} height={20} />
          <div className="mt-2">
            <Skeleton width={150} height={40} />
          </div>
          <div className="mt-5 p-4 bg-amber-50 rounded-lg">
            <Skeleton count={2} />
          </div>
        </div>

        {/* Right panel - Filter options */}
        <div className="flex-1">
          <div className="flex flex-wrap gap-2 mb-5">
            {/* Date filters */}
            {[1, 2, 3, 4].map((item) => (
              <div key={item} className="w-32">
                <Skeleton height={32} borderRadius={16} />
              </div>
            ))}

            {/* Date range picker */}
            <div className="w-48">
              <Skeleton height={32} />
            </div>
          </div>

          {/* Payment type cards */}
          <div className="grid grid-cols-4 gap-4">
            {[1, 2, 3, 4].map((item) => (
              <div key={item} className="p-5 rounded-lg shadow h-40">
                <div className="flex justify-center mb-4">
                  <Skeleton circle width={40} height={40} />
                </div>
                <div className="text-center">
                  <Skeleton width={80} className="mx-auto" />
                  <div className="mt-4">
                    <Skeleton width={100} height={30} className="mx-auto" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiltersSectionSkeleton;
